import React from 'react'
import { Link } from "react-router-dom";


const OurFacilites = () => {
  return (
    <>
      <section className="department-one" style={{ marginTop: "-80px" }}>
        <div className="department-one_image" style={{ backgroundImage: 'url(assets/images/background/1.jpg)' }} />
        <div className="auto-container">
          <div className="sec-title light centered" style={{ marginTop: "-70px" }}>
            <div className="sec-title_title">Our Gallery</div>
            <h2 className="sec-title_heading">Our Departments Gallery</h2>
          </div>
          <div className="auto-container">
            <div className="row clearfix">
              <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                <div className="news-block_one-inner wow fadeInLeft" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                  <div className="news-block_one-image">
                    <Link to="/gallery"><img src="assets/img/Gallery_3.webp" alt /></Link>
                  </div>
                </div>
              </div>
              <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                <div className="news-block_one-inner wow fadeInUp" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                  <div className="news-block_one-image">
                    <Link to="/gallery"><img src="assets/img/Gallery_2.webp" alt /></Link>
                  </div>
                </div>
              </div>
              <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                  <div className="news-block_one-image">
                    <Link to="/gallery"><img src="assets/img/Gallery_4.webp" alt /></Link>
                  </div>

                </div>
              </div>
              <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                  <div className="news-block_one-image">
                    <Link to="/gallery"><img src="assets/img/Gallery_5.jpeg" alt /></Link>
                  </div>

                </div>
              </div>
              <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                  <div className="news-block_one-image">
                    <Link to="/gallery"><img src="assets/img/Gallery_8.jpeg" alt /></Link>
                  </div>

                </div>
              </div>
              <div className="news-block_one col-lg-4 col-md-6 col-sm-12">
                <div className="news-block_one-inner wow fadeInRight" style={{ visibility: '', animationDuration: '1500ms', animationDelay: '0ms', animationName: 'none' }}>
                  <div className="news-block_one-image">
                    <Link to="/gallery"><img src="assets/img/Gallery_7.jpeg" alt /></Link>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  )
}

export default OurFacilites